module.exports = __webpack_public_path__ + "static/media/mode-10.cacaf207.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-10.svg
// module id = 983
// module chunks = 2